import axios from "axios";


// const COUNSELLOR_API_BASE_URL = "https://counsellor.echobuddy.in/api/v1";
const COUNSELLOR_API_BASE_URL = "http://103.186.133.119:5177/api/v1";


export const getReviewByAppointmentId = async (appointmentId) => {
  try {
    const response = await axios.get(
      `${COUNSELLOR_API_BASE_URL}/reviews/appointment/${appointmentId}`
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};


export const addReview = async (reviewData) => {
  try {
    const response = await axios.post(`${COUNSELLOR_API_BASE_URL}/reviews`, reviewData);
    return response.data;
  } catch (error) {
    console.error('Error adding review:', error.response?.data || error.message);
    throw error;
  }
};

export const updateReview = async (appointmentId, reviewData) => {
  try {
    const response = await axios.patch(
      `${COUNSELLOR_API_BASE_URL}/reviews/${appointmentId}`,
      reviewData
    );
    return response.data;
  } catch (error) {
    console.error('Error updating review:', error.response?.data || error.message);
    throw error;
  }
};


export const deleteReview = async (appointmentId) => {
  try {
    await axios.delete(`${COUNSELLOR_API_BASE_URL}/reviews/${appointmentId}`);
    return true;
  } catch (error) {
    console.error('Error deleting review:', error.response?.data || error.message);
    throw error;
  }
};

export default {
  getReviewByAppointmentId,
  addReview,
  updateReview,
  deleteReview
};